'use client'

import { useQuery } from '@tanstack/react-query'

import axios from '@/_lib/axiosInstance'
import { ApiResponse, IInsuranceCompany } from '@/_types'

/**
 * Loads insurers for patient forms and template pricing displays in the order funnel.
 */
export const fetchInsuranceCompanies = async (): Promise<ApiResponse<IInsuranceCompany[]>> => {
	return axios
		.get<ApiResponse<IInsuranceCompany[]>>(`v1/web/insuranceCompanies`)
		.then(res => res.data)
}

/**
 * React Query hook for {@link fetchInsuranceCompanies}.
 */
export const useGetInsuranceCompanies = () => {
	return useQuery<ApiResponse<IInsuranceCompany[]>>({
		queryKey: ['insurance-companies'],
		queryFn: () => fetchInsuranceCompanies(),
		select: data => data
	})
}
